/**
 * Bỏ <br> "rác" (thường dán từ Facebook/Word) nằm ngay ĐẦU hoặc CUỐI một đoạn <p>.
 *
 * Những <br> này tạo dòng trống ngẫu nhiên khiến khoảng cách nội dung ngoài web bị
 * loạn, trong khi khung soạn thảo WYSIWYG của CKEditor vốn KHÔNG hiển thị chúng
 * (CKEditor tự loại <br> đầu/cuối đoạn khi render). Dọn ở tầng render giúp public
 * khớp đúng với editor và mọi bài cũ đẹp ngay mà không phải sửa dữ liệu gốc.
 *
 * Giữ nguyên đoạn trống cố ý <p><br></p> (khi <br> là toàn bộ nội dung của đoạn) và
 * <br> nằm giữa câu (ngắt dòng có chủ đích).
 */
export const stripStrayBr = (html: string): string => {
  if (!html) return html

  // 1) <br> ở đầu đoạn: ngay sau thẻ mở <p ...>, chỉ bỏ khi đoạn còn nội dung khác.
  html = html.replace(/(<p\b[^>]*>)(\s*(?:<br\b[^>]*>\s*)+)/gi, (full, open, _brs, offset, str) => {
    const rest = (str as string).slice(offset + full.length)
    if (/^\s*<\/p>/i.test(rest)) return full // <p><br></p> rỗng → giữ nguyên
    return open
  })

  // 2) <br> ở cuối đoạn: ngay trước </p>, chỉ bỏ khi đoạn còn nội dung khác.
  html = html.replace(/(\s*(?:<br\b[^>]*>\s*)+)(<\/p>)/gi, (full, _brs, close, offset, str) => {
    const before = (str as string).slice(0, offset)
    if (/<p\b[^>]*>\s*$/i.test(before)) return full // đoạn chỉ gồm <br> → giữ nguyên
    return close
  })

  return html
}
